import { atom } from 'recoil';

export const inflightCadencesSearch = atom({
  key: 'inflightCadencesSearch',
  default: '',
});
